import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { AuthFrame } from "@/components/AuthFrame";
import { NewPhoneFlow } from "@/features/auth/NewPhoneFlow";
import { signedIn, useGo } from "@/features/auth/afterSignIn";
import { isSessionGone } from "@/lib/api";
import { meQuery } from "@/lib/auth";

// Straight after signing in with a recovery code (I-m-herstel → I-m-app): a new phone before anything
// else. Nothing else of the portal answers this session until it is linked (docs/auth.md §3a).

export const Route = createFileRoute("/new-phone")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.fetchQuery({ ...meQuery, staleTime: 0 }).catch((err: unknown) => {
      if (isSessionGone(err)) throw redirect({ to: "/login" });
      throw err;
    });
    if (!me.mustRelink) throw redirect({ to: "/account/phone" });
  },
  component: NewPhoneScreen,
});

function NewPhoneScreen() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const go = useGo();
  const { data: me } = useSuspenseQuery(meQuery);
  return (
    <AuthFrame label="Portaal Nieuwe telefoon" step={t("phone.stepLabel")} wide>
      <NewPhoneFlow me={me} forced onDone={(linked) => void go(signedIn(queryClient, linked))} />
    </AuthFrame>
  );
}
